export default "__VITE_ASSET__k3aYy6Qn__";